export function createRoute(config) {
    return {
        ...config,
        getPath() {
            let counter = 0;
            return config.path
              .replace(/:\w+/g, (...args) => {
                return encodeURIComponent(arguments[counter++] || '');
              })
              .replace(/\/\//g, '/')
              .replace(/\/$/, '');
        }
    };
}
